import { ComponentView, View } from "binder"
import { GuageViewModel } from "./guage-viewModel"
// declare function getNewGuage(params:any);
declare var Gauge: (any) => void;

export class GuageView extends ComponentView<GuageViewModel> {
    GetViewUniqueId(): string {
        return "V-F9DA8EA2-9240-46B4-93AA-4EB114B1F795"
    }
    loadHtml(): string {
        let element = require('./guage.html').default;
        let style = require('./guage.less');
        return element;
    }
    constructor() {
        super();
    }

    private isRendered: boolean = false;
    private guagePlaceHolder: any;
    private textPlaceHolder: any;
    private guage: any;


    public set config(v: any) {
        this._config = v;
        this.CreateGauge();
    } public get config(): any { return this._config; } private _config: any;
    public set value(v: number) {
        this._value = v;
        this.CreateGauge();
    } public get value(): number { return this._value; } private _value: number;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;


    public onRenderCompleted() {
        this.guagePlaceHolder = this.firstlevelElement.querySelector('.V-F9DA8EA2-9240-46B4-93AA-4EB114B1F795-guage-placeholder')
        this.textPlaceHolder = this.firstlevelElement.querySelector('.V-F9DA8EA2-9240-46B4-93AA-4EB114B1F795-text-placeholder')
        setTimeout(()=>{
            this.isRendered = true;
            this.CreateGauge();
        },100);
    }
    private isInverted():boolean{
        if(document.body.classList.contains('inverted-theme')){
            return true;
        }
        return false;
    }
    private CreateGauge() {
        if (this.isRendered == false)
            return;

        let baseConfig: any = {

        };
        if (this.config != null) {
            if (this.config.staticZones != null) {
                baseConfig.staticZones = this.config.staticZones;
            }
        }

        if (this.guage == null) {
            this.guage = new Gauge(this.guagePlaceHolder);
            this.guage.setTextField(this.textPlaceHolder,2);
        }
        if(this.config && this.isInverted()){
            if(this.config.pointer){
                this.config.pointer.color = '#000000'
            }else{

            }
            if(this.config.staticLabels){
                this.config.staticLabels.color = '#000000'
            }else{
                
            }
        }
        this.guage.setOptions(this.config ?? {});
        this.guage.minValue = this.config?.minValue ?? 0;
        this.guage.maxValue = this.config?.maxValue ?? 100;
        this.guage.animationSpeed = 16;
        if (this.value != null) {
            this.guage.set(this.value);
        } else {
            this.guage.set(0);
        }
    }
}
